<template>
    <div class="animated-logo" :class="{animate: this.$store.state.onboarded}">
      <img class="logo" src="@/assets/logo.svg" />
      <img class="star" src="@/assets/star.svg" />
      <img class="star" src="@/assets/star.svg" />
      <img class="star" src="@/assets/star.svg" />
      <img class="star" src="@/assets/star.svg" />
      <img class="star" src="@/assets/star.svg" />

      <div class="ride-reveal">
        <img src="@/assets/rides/peterpan/cover.jpg" />
      </div>

      <div class="attraction-logo">
        <img src="@/assets/rides/peterpan/logo.svg" />
      </div>
    </div>
</template>

<script>
export default {
  name: 'animatedLogo',
  props: {
    animate: false
  }
}
</script>


// WEBPACK FOOTER //
// src/components/animatedLogo.vue